import React from 'react'
import { AdminPageWrapper, DeveloperData, PageHeader, TCancelButton } from 'components'
import { useHistory, useLocation } from 'react-router-dom'

const CreateEditDeveloper = () => {
  const location = useLocation()
  const history = useHistory()

  const {
    state: {
      _id
    }
  } = location

  const RightContent = () => (
    <TCancelButton
      onClick={() => history.goBack()}
    >
      Back
    </TCancelButton>
  )

  return (
    <>
      <PageHeader
        title={`${_id ? 'Editing' : 'Creating new'} developer`}
        rightContent={<RightContent />}
      />
      <AdminPageWrapper>
        <DeveloperData
          _id={_id}
        />
      </AdminPageWrapper>
    </>
  )
}

export default CreateEditDeveloper
